import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

/* Voorstel 52: nieuwe opmaak per werkruimte achter flag `layout_v2`.
   Stand komt van de server (/layout-v2/stand): flag, schakelrecht (directie/testers), eigen voorkeur, actief.
   localStorage is alleen een cache zodat de eerste render niet flikkert. */
const SLEUTEL = "bpt_layout_v2_stand";
const LEEG = { flag_aan: false, tester: false, voorkeur: null, actief: false, mag_schakelen: false, terug_tot: null, label: "Nieuwe opmaak proberen" };
const Ctx = createContext({ ...LEEG, geladen: false, zet: async () => {}, herlaad: async () => {} });

const leesCache = () => { try { return JSON.parse(localStorage.getItem(SLEUTEL) || "null") || LEEG; } catch { return LEEG; } };

export function LayoutV2Provider({ children }) {
  const { user } = useAuth();
  const [stand, setStand] = useState(leesCache);
  const [geladen, setGeladen] = useState(false);
  const herlaad = useCallback(async () => {
    if (!user) { setStand(LEEG); return; }
    try { const { data } = await api.get("/layout-v2/stand", { bptStil: true }); setStand(data); localStorage.setItem(SLEUTEL, JSON.stringify(data)); }
    catch { /* oude opmaak blijft */ }
    setGeladen(true);
  }, [user?.id]); // eslint-disable-line
  useEffect(() => { herlaad(); }, [herlaad]);
  const zet = useCallback(async (voorkeur) => {
    const { data } = await api.put("/layout-v2/voorkeur", { voorkeur });
    setStand(data); localStorage.setItem(SLEUTEL, JSON.stringify(data));
    return data;
  }, []);
  const waarde = useMemo(() => ({ ...stand, geladen, zet, herlaad }), [stand, geladen, zet, herlaad]);
  return React.createElement(Ctx.Provider, { value: waarde }, children);
}

export const useLayoutV2 = () => useContext(Ctx);
